export default {
  extract (string: string, pattern: RegExp) {
    let result = null
    if (string !== null) {
      const matches = pattern.exec(string)
      if (matches !== null && matches.length > 0) {
        result = matches[1]
      }
    }
    return result
  }
}

export const phoneRegex = /^((\+44)|(0)) ?\d{4} ?\d{6}$/
